import { buildTestIds, formatCurrency } from "application";
import { IconStore, TruckFC, theme } from "ui";
import { ShippingOptions } from "typing";
import { memo } from "react";
import {
  BoxInfoShipping,
  ColumnArrivesText,
  ColumnArrivesTextWrapper,
  ColumnTable,
  ColumnTableFreeShipping,
  // DescriptionText,
  FlagShipping,
  InfoTableShipping,
  LineTable,
  ShippingCircleIcon,
  ShippingText,
  TitleFlag,
} from "./styles";
import { useFormatShippingText } from "./data";

interface InfoShippingBoxProps {
  shippingType: "delivery" | "pickUpInStore";
  shippingInfo: ShippingOptions[];
}

const InfoShippingRow = memo(
  ({
    shipping,
    shippingType,
  }: {
    shipping: ShippingOptions;
    shippingType: "delivery" | "pickUpInStore";
  }) => {
    const shippingTextContent = useFormatShippingText(
      shipping?.arrivesText || ""
    );
    return (
      <LineTable {...buildTestIds("shipping-line-table")}>
        <ColumnArrivesTextWrapper key={shipping?.arrivesText}>
          <ShippingText
            {...buildTestIds("title-column-table-product-description")}
          >
            {shippingTextContent}
          </ShippingText>
          {shippingType === "pickUpInStore" &&
            shipping?.pickUpInStoreLocation?.store && (
              <ColumnArrivesText>{`Unidade ${
                // eslint-disable-next-line no-unsafe-optional-chaining
                shipping?.pickUpInStoreLocation?.store.charAt(0).toUpperCase() +
                // eslint-disable-next-line no-unsafe-optional-chaining
                shipping?.pickUpInStoreLocation?.store.slice(1).toLowerCase()
              }`}</ColumnArrivesText>
            )}
        </ColumnArrivesTextWrapper>
        {shipping?.value === 0 ? (
          <ColumnTableFreeShipping>
            <ColumnTable
              {...buildTestIds("title-column-table-free")}
              color={theme.colors.neutral.white}
            >
              Grátis
            </ColumnTable>
          </ColumnTableFreeShipping>
        ) : (
          <ColumnTable {...buildTestIds("column-table-price-value")}>
            {formatCurrency(shipping?.value)}
          </ColumnTable>
        )}
      </LineTable>
    );
  }
);

export const InfoShippingBox = memo(
  ({ shippingType, shippingInfo }: InfoShippingBoxProps) => {
    return (
      <BoxInfoShipping
        {...buildTestIds("view-zipcode-search-box-info-shipping")}
      >
        <FlagShipping {...buildTestIds("view-zipcode-search-flag-shipping")}>
          <ShippingCircleIcon
            {...buildTestIds("zipcode-search-shipping-circle-icon")}
          >
            {shippingType === "delivery" ? <TruckFC /> : <IconStore />}
          </ShippingCircleIcon>
          <TitleFlag {...buildTestIds("view-zipcode-search-title-flag")}>
            {shippingType === "delivery" ? "Receba em casa" : "Retire na loja"}
          </TitleFlag>
        </FlagShipping>
        <InfoTableShipping
          {...buildTestIds("view-zipcode-search-info-table-shipping")}
        >
          {shippingInfo?.map((shipping) => (
            <InfoShippingRow
              key={shipping?.deliveryTypeId}
              shippingType={shippingType}
              shipping={shipping}
            />
          ))}
        </InfoTableShipping>
      </BoxInfoShipping>
    );
  }
);

InfoShippingRow.displayName = "Info Shipping Row";
InfoShippingBox.displayName = "Info Shipping Box";
